module.exports = __webpack_public_path__ + "static/img/dt2.2f342f5d.png";